import { IMultipleIdsParams } from '../types/actionParams';
import { IActionResult } from '../types/IActionResult';
import { Request } from './Request';

export class SetContentControlledPermissionsRequest
    extends Request<IMultipleIdsParams, IActionResult> {
  constructor(ids: string[]) {
    super('setContentControlledPermissions', {
      ids: ids
    });
  }
}
